import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormArray,Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { EncryptionService } from "src/app/services/encryption.service";
import { AppService } from "src/app/services/services";
import { NomineeComponent } from "../nominee/nominee.component";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
    selector: 'nri-app-fatca',
    templateUrl: './fatca.component.html',
    styleUrls: ['./fatca.component.scss']
})

export class FatcaComponent implements OnInit{
    taxResident: string = 'N';
    fatcaForm: FormGroup;
    countryList: any;
    countryLists:any;
    docTypeList: any;
    erefNo: any;
    fatcaID: any = '';
    tax: any;
    existingDemat: boolean;
    panNumber: any;
    title: any;
    titleError: boolean = false;
    name: string = '';
    codeKeyword = 'TeleCode';
    nameList = [
        { value: 'MR', label: 'MR' },
        { value: 'DR', label: 'DR' },
        { value: 'MRS', label: 'MRS' },
        { value: 'MISS', label: 'MISS' },
        { value: 'MS', label: 'MS' },
        { value: 'MX', label: 'MX'}
      ];
      mobileNumber:any;
      relationName: any;
      relationNameEmpty:boolean = false;
      nriMobile: any;
      occupationList: any[] = [];
    Occupation: string = "";
    nriEmail: any;
    AnnualIncome:string = "";
    incomeList: any = '';
    tradingExp:string = "";
    countryCode: any;
    countryCodeError: boolean;
    disableCountrycode:boolean = true;
    disableMobileEdit: boolean = false;
    oldMobile: any;
    oldCountrycode: any;
    mobValidatebtn: boolean = false;
    mobCancel: boolean = false;
    tradingExperience:any = [];
    decryptPan:string;
    firstName:string = "";
    middleName:string = "";
    lastName:string = "";
    nameDisabled:boolean = false;
    titleDisabled:boolean = false;
    disableEmailEdit: boolean = false;
    @ViewChild('nominee') nominee:NomineeComponent;
    oldNriEmail: any;
    emailValidatebtn: boolean = false;
    emailCancel: boolean = false;
    stageValidated: boolean = false;
    otptriggermob:boolean = false;
    otptriggerEmail:boolean = false;  
    rmfullemail: string;
    rmEmail: any = null;
    rmAssist: boolean = false;
    rmDomain: string = '@axisbank.com';
    reSendOTP: boolean = false;
    emailOTP: any = '';
    showOTP: boolean;
    otpError: boolean = false;
    nomineeStatus:boolean;
    TaxImage1Id:any;
    TaxImage2Id:any;
    TaxImage3Id:any;
    imageone:boolean = false;
    imagetwo:boolean = false; 
    imagethree:boolean = false;
    getFatca:boolean = false;
    getFatca2: boolean = false;
    getFatca1: boolean = false;
    fatcaArray: Array<any> = [{
      fatca1: false,
      fatca2: false
    }]
    @ViewChild('errorComp') errorComp : ErrorModalComponent;
    errorMess:string = "";
    citizenShip : string = "";
    countryOFBirth : string = "";
    constructor(private formBuilder: FormBuilder, public _http: AppService,private http:EncryptionService, private router: Router, private loader: NgxUiLoaderService, public toastr: ToastrService){
        this._http.getRefNum().subscribe(data=>{
            this.erefNo = data;
        });
        this._http.getStatus().subscribe(data=>{
            this.panNumber = data.Pan;
        })
        this.countryList = this._http.countryList;
        this.countryLists = this._http.countryList;
        this.countryList = this.countryList.filter((e: any) => {
            return e.Name !== "India";
          });
        this.fatcaForm = this.formBuilder.group({
            CTR: ['', Validators.required],
            TID: ['', Validators.required],
            TIN: ['', [Validators.required, Validators.maxLength(30)]],
            ADDRESS: ['', Validators.required],
            FatcaDetailsId: [''],
            items: this.formBuilder.array([]),
        });

        this._http.getMasters().subscribe(data=>{
            if(data && data.DocumentTypeList){
                this.docTypeList = data.DocumentTypeList.filter((e:any) => {
                    return e.DocumentCategory == 6;
                })
                this._http.getStatus().subscribe(d=>{
                  
                    // this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
                    //   return !e.OCI
                    // })
                  
                })
            }
        });
    }
    ngOnInit() {
        this._http.scroll();
        this.overallStatus();
        this._http.getMasters().subscribe(data=>{
            if(data && data.OccupationList){
              this.occupationList = data.OccupationList
            }
            if(data && data.IncomeList){
              this.incomeList = data.IncomeList
            }
            if(data && data.TradingExpList){
                this.tradingExperience = data.TradingExpList;
            }
          });
        this.getFatcaInfo();
        if(this.panNumber){
            // this.geAccountTypes();
        }else{
            let url = 'DIY/DIYOverallStatus';
            this.loader.start();
            let checkSum = this.erefNo;    
            let params = {
            'ReferenceNumber': this.erefNo,
            }
            this._http.httpPost(url,params, checkSum).subscribe({
            next: (data:any) => {
                this.loader.stop();
                let val=this.http.decryptUsingAES256(data.OutPut)
                if(val && val.IsSuccess){
                let item = val.overallLists;
                this.panNumber = val.PanNumber;
                // this.geAccountTypes();
                }
        
            },
            error: _error=>{
                this.loader.stop();
                this.errorComp.ModalShow(_error.error.Message);
                // this.toastr.error(_error.error.Message)
            }
            })
            }
    }

    geAccountTypes(){
        let url = "DIY/SubAcVerify";

        let params = {
            "ReferenceNumber": this.erefNo,
            "PanNumber": this.panNumber
        }

        const checkSum = this.erefNo + this.panNumber;

        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data:any)=>{
                let val=this.http.decryptUsingAES256(data.OutPut)
                if(val.IsSuccess){ 
                    this.existingDemat = val.ExistingDemat;
                    
                }
            },
            error: _error =>{

            }
        })
    }

    overallStatus(){
        let url = 'DIY/DIYOverallStatus';
        this.loader.start();
        let checkSum = this.erefNo;    
        let params = {
          'ReferenceNumber': this.erefNo,
        }
        this._http.httpPost(url,params, checkSum).subscribe({
          next: (data:any) => {
            this.loader.stop();
            let val=this.http.decryptUsingAES256(data.OutPut)
            if(val && val.IsSuccess){
              let item = val.overallLists;
              this.panNumber = val.PanNumber;
              sessionStorage.setItem("NomPan",val.NomPan);
              sessionStorage.setItem("ClientName",val.ClientName);
               sessionStorage.setItem("ClientEmail",val.Email);
              sessionStorage.setItem("CountryCode",val.CountryCode);
               sessionStorage.setItem("ClientMobile",val.Mobile);
            //   this.geAccountTypes();
            if(val.IsRMJourney){
                this.rmAssist = true;
            }
            else{
                this.rmAssist = false;
            }
            }
      
          },
          error: _error=>{
            this.loader.stop();
            this.errorComp.ModalShow(_error.error.Message);
            // this.toastr.error(_error.error.Message)
          }
        })
      }

    get itemsArr() {
        return this.fatcaForm.get('items') as FormArray;
    }

    getItemsFromArr(index: number){
        const formGroup = this.itemsArr.controls[index] as FormGroup;
        return formGroup;
    }

    getFatcaInfo(){
        let url = "DIY/DIYGetFatca";

        let params = {
            "ReferenceNumber": this.erefNo
        }

        let checkSum = this.erefNo;
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data:any)=>{
                this.loader.stop();
                let val = this.http.decryptUsingAES256(data.OutPut);
                if(val && val.IsSuccess){
                  if (val.FATCA_BIRTH_COUNTRY) {
                    this.countryOFBirth = val.FATCA_BIRTH_COUNTRY;
                  }
                  if (val.FATCA_COUNTRY_CITYZENSHIP) {
                    this.citizenShip = val['FATCA_COUNTRY_CITYZENSHIP'];
                  }
                    if(val.Fatca[0].FirstName){
                        this.name = val.Fatca[0].FirstName;
                        this.nameDisabled = true;
                        this.firstName = val.Fatca[0].FirstName;
                      }
                      if(this.name && val.Fatca[0].MiddleName){
                        this.name =  this.name+' '+val.Fatca[0].MiddleName;
                        this.nameDisabled = true;
                        this.middleName = val.Fatca[0].MiddleName;
                      }else if(val.Fatca[0].MiddleName){
                        this.name = val.Fatca[0].MiddleName;
                        this.nameDisabled = true;
                        this.middleName = val.Fatca[0].MiddleName;
                      }
              
                      if(this.name && val.Fatca[0].LastName){
                        this.name =  this.name+' '+val.Fatca[0].LastName;
                        this.nameDisabled = true;
                        this.lastName = val.Fatca[0].LastName;
                      }else if(val.Fatca[0].LastName){
                        this.name = val.Fatca[0].LastName;
                        this.nameDisabled = true;
                        this.lastName = val.Fatca[0].LastName;
                      }
                    this.decryptPan = val.Fatca[0].PanNumber;
                    if(val.Fatca[0].Email){
                        this.nriEmail = val.Fatca[0].Email;
                    }
                    if(val.Fatca[0].FatherOrSpouseName){
                        this.relationName = val.Fatca[0].FatherOrSpouseName;
                    }
                    if(val.Fatca[0].Mobile){
                        this.nriMobile = val.Fatca[0].Mobile;
                    }
                    if(val.Fatca[0].MobCountryCode){
                        this.countryCode = val.Fatca[0].MobCountryCode;
                    }
                    if(val.Fatca[0].TradingExperience){
                        this.tradingExp = val.Fatca[0].TradingExperience;
                    }
                    if(val.Fatca[0].Title){
                        this.title = val.Fatca[0].Title;
                        if(this.title.toUpperCase() !== 'MX'){
                          this.titleDisabled = true;
                        }else{
                          this.title = 'MR'
                        }
                    }
                    if(val.Fatca[0].Occupation){
                        this.Occupation = val.Fatca[0].Occupation;
                    }
                    if(val.Fatca[0].AnnualIncome){
                        this.AnnualIncome = val.Fatca[0].AnnualIncome;
                    }
                    this.tax = val.Fatca.map((x:any) => {
                        return x.IndianTaxer
                    })

                    if(this.tax.some((value:any) => value === true)){
                        this.taxResident = 'Y';
                    }
                    else{
                        this.taxResident = 'N';
                        let len = val.Fatca.length;
                        this.TaxImage1Id = val.Fatca[0].FatcaDetailsId;
                        this.getFatca = true;
                        this.fatcaForm.patchValue({
                            CTR: val.Fatca[0].TaxCountry,
                            TID: val.Fatca[0].TinCountry,
                            TIN: val.Fatca[0].TIN,
                            ADDRESS: val.Fatca[0].DocName,
                            FatcaDetailsId: val.Fatca[0].FatcaDetailsId
                        });
                        if(len > 0 && val.Fatca[1] && val.Fatca[1].FatcaDetailsId){
                            this.TaxImage2Id = val.Fatca[1].FatcaDetailsId;
                            this.getFatca1 = true;
                            this.fatcaArray[0].fatca1 = true;
                        }
                        if(len > 1 && val.Fatca[2] && val.Fatca[2].FatcaDetailsId){
                          this.TaxImage3Id = val.Fatca[2].FatcaDetailsId;
                          this.getFatca2 = true;
                          this.fatcaArray[0].fatca2 = true;
                        }

                        if(len > 1){
                            for(let i = 1; i<len; i++){
                                this.itemsArr.push(
                                    this.formBuilder.group({
                                        ADDCTR: [val.Fatca[i].TaxCountry, Validators.required],
                                        ADDTID: [val.Fatca[i].TinCountry, Validators.required],
                                        ADDTIN: [val.Fatca[i].TIN, Validators.required],
                                        ADDADDRESS: [val.Fatca[i].DocName, Validators.required],
                                        ADDFatcaDetailsId: [val.Fatca[i].FatcaDetailsId]
                                    })
                                );
                            }
                        }

                    }
                }
            },error: error=>{
                this.loader.stop();
            }
        })
    }

    addItem(i?:any){
      if(i === 0){
        this.fatcaArray[0].fatca1 = true;
      }
      if(i === 1){
        this.fatcaArray[0].fatca2 = true;
      }
        this.itemsArr.push(
            this.formBuilder.group({
                ADDCTR: ['', Validators.required],
                ADDTID: ['', Validators.required],
                ADDTIN: ['', [Validators.required ,Validators.maxLength(30)]],
                ADDADDRESS: ['', Validators.required],
                ADDFatcaDetailsId: ['']
            })
        );        
    }

    removeItem(i: number) {
      if((i === 0 && this.itemsArr.length === 2) || (i === 0 && this.itemsArr.length === 1)){
        this.fatcaArray[0].fatca1 = false;
      }
      if(i === 1 || this.itemsArr.length === 1){
        this.fatcaArray[0].fatca2 = false;
        if(this.imagethree){
          this.imagethree = false;
        }
      }
       
        if(this.fatcaForm.value.items[i].ADDFatcaDetailsId){
            let url = "DIY/DeleteFATCA";
            let checkSum = this.erefNo + this.fatcaForm.value.items[i].ADDFatcaDetailsId;
            let params = {
                "ReferenceNumber": this.erefNo,
                "FatcaId": this.fatcaForm.value.items[i].ADDFatcaDetailsId
            }
            
            this._http.httpPost(url, params, checkSum).subscribe();
        }
        this.itemsArr.removeAt(i);
    }

    status(event:boolean) {
      this.nomineeStatus = event;
      if(this.nomineeStatus){
        this.nextStage();
      }
    }

    imageURL(event:any){
      if(event.url && event.name === "TaxImage1"){
        this.imageone = true;
      }
      if(event.url && event.name === "TaxImage2"){
        this.imagetwo = true;
      }
      if(event.url && event.name === "TaxImage3"){
        this.imagethree = true;
      }
      if(!event.url && event.name === "TaxImage1"){
        this.imageone = false;
      }
      if(!event.url && event.name === "TaxImage2"){
        this.imagetwo = false;
      }
      if(!event.url && event.name === "TaxImage3"){
        this.imagethree = false;
      }


    }
    fatcaEvent(event:any){
      let fatcArray = [];
      if(event.id && event.name === "TaxImage1"){
        this.TaxImage1Id = event.id;
        this.fatcaForm.patchValue({
          FatcaDetailsId:event.id
        })
      }
      if(event.id && event.name === "TaxImage2"){
        this.TaxImage2Id = event.id;
        fatcArray.push(this.TaxImage2Id);
        this.fatcaForm.value.items[0].ADDFatcaDetailsId = this.TaxImage2Id;

      }
      if(event.id && event.name === "TaxImage3"){
        this.TaxImage3Id = event.id;
        fatcArray.push(this.TaxImage3Id);
        this.fatcaForm.value.items[1].ADDFatcaDetailsId = this.TaxImage3Id;
      }
    //   const len = fatcArray.length;
    //   if(len > 0){
    //     for(let i = 0; i<len; i++){
    //          this.itemsArr.push(
    //             this.formBuilder.group({
    //                 ADDCTR: ['', Validators.required],
    //                 ADDTID: ['', Validators.required],
    //                 ADDTIN: ['', [Validators.required,this.validateAlphanumeric,Validators.maxLength(30)]],
    //                 ADDADDRESS: ['', Validators.required],
    //                 ADDFatcaDetailsId: [fatcArray[i]]
    //             })
    //          );
    //     }
    // }
    }

    nextStage(){
        if (!this.citizenShip || !this.countryOFBirth) {
          this.errorComp.ModalShow(!this.citizenShip ? 'Please Select Citizenship' : 'Please Select Country of Birth');
          return;
        }
        if(!this.imageone){
          this.errorComp.ModalShow("Please Upload Tax Image")
          // this.toastr.error("Please Upload Tax Image");
          return;
        }
        if(this.itemsArr.length > 0 && !this.imagetwo){
          this.errorComp.ModalShow("Please Upload Tax Image");
          // this.toastr.error("Please Upload Tax Image");
          return;
        }
        if(this.itemsArr.length === 2 && !this.imagethree){
          this.errorComp.ModalShow("Please Upload Tax Image");
          // this.toastr.error("Please Upload Tax Image");
          return;
        }

        if(this.otptriggerEmail){
          this.validateOTP();
          return;
        }
        const fields = [
          { field: this.title, message: "Please Provide Title" },
          { field: this.relationName, message: "Please Provide Father Name" },
          { field: this.Occupation, message: "Please Select Your Occupation" },
          { field: this.AnnualIncome, message: "Please Select Annual Income" },
          { field: this.tradingExp, message: "Please Select Trading Experience" },
          { field: this.nriEmail, message: "Please Provide Email"},
          { field: this.nriMobile, message: "Please Provide Mobile Number"},
          { field: this.countryCode, message: "Please Provide Country Code"}
      ];
      for (const { field, message } of fields) {
          if (!field) {
              this.errorMess = message;
              this.errorComp.ModalShow(message);
              // this.toastr.error(message);
              return;
          }
      }
      let ccode = '';
      if(this.countryCode.TeleCode){
      ccode =  this.countryCode.TeleCode;
      }else{
      ccode = this.countryCode;
      }
      let params:any = '';
      const TIN = this.fatcaForm.value.TIN;
      const ADDTIN0 = this.fatcaForm.value.items[0]?.ADDTIN;
      const ADDTIN1 = this.fatcaForm.value.items[1]?.ADDTIN;

      const country1 = this.fatcaForm.value.CTR;
      const country2 = this.fatcaForm.value.items[0]?.ADDCTR;
      const country3 = this.fatcaForm.value.items[1]?.ADDCTR;

      const add = this.fatcaForm.value.ADDRESS;
      const add1 = this.fatcaForm.value.items[0]?.ADDADDRESS;
      const add2 = this.fatcaForm.value.items[1]?.ADDADDRESS;
      console.log(typeof(add) , add.trimStart().length);
      
      if(typeof(add) === "string" && add.trimStart().length === 0) {
        this.errorComp.ModalShow("Please Enter Document Name");
        return
      }
      if(typeof(add1) === "string" && add1.trimStart().length === 0){
        this.errorComp.ModalShow("Please Enter Document Name");
        return
      }
      if(typeof(add2) === "string" && add2.trimStart().length === 0){
        this.errorComp.ModalShow("Please Enter Document Name");
        return
      }
      
      if ((TIN && TIN === ADDTIN0) || (TIN && TIN === ADDTIN1)) {
          this.errorComp.ModalShow("Values cannot be same");
          // this.toastr.error("Values cannot be same");
          return;
      } else if (ADDTIN0 && ADDTIN1 && ADDTIN0 === ADDTIN1) {
          this.errorComp.ModalShow("Values cannot be same");
          // this.toastr.error("Values cannot be same");
          return;
      } 

      if ((country1 && country1 === country2) || (country1 && country1 === country3)) {
          this.errorComp.ModalShow("Countries cannot be same");
          // this.toastr.error("Countries cannot be same");
          return;
      } else if (country2 && country3 && country2 === country3) {
          this.errorComp.ModalShow("Countries cannot be same");
          // this.toastr.error("Countries cannot be same");
          return;
      } 
      // if(this.fatcaForm.value.TIN === this.fatcaForm.value.items[0]?.ADDTIN || this.fatcaForm.value.TIN === this.fatcaForm.value.items[1]?.ADDTIN || this.fatcaForm.value.items[0]?.ADDTIN == this.fatcaForm.value.items[1]?.ADDTIN){
      //     this.toastr.error("Values cannot be same");
      //     return;
      // }
      else{
      params = {
          "Fatca":[
              {
                  "AddressType": "",
                  "TIDocument": 0,
                  "TIN": this.fatcaForm.value.TIN,
                  "TaxCountry": this.fatcaForm.value.CTR,
                  "IndianTaxer": false,
                  "FatcaDetailsId": this.fatcaForm.value.FatcaDetailsId,
                  "Title": this.title,
                  "FirstName": "",
                  "MiddleName":"",
                  "LastName":this.name,
                  "ClientName":"",
                  "FatherOrSpouse":"F",
                  "FatherOrSpouseName":this.relationName,
                  "Occupation":this.Occupation,
                  "AnnualIncome":this.AnnualIncome,
                  "TradingExperience":this.tradingExp,
                  "TinCountry": this.fatcaForm.value.TID,
                  "DocName": this.fatcaForm.value.ADDRESS
              },
          ],
          "ReferenceNumber": this.erefNo,
          "MobCountryCode":ccode,
          "Mobile":this.nriMobile,
          "Email":this.nriEmail,
          "PanNumber":this.decryptPan,
          "FATCA_COUNTRY_CITYZENSHIP" : this.citizenShip,
          "FATCA_BIRTH_COUNTRY" : this.countryOFBirth
      }

      let len = this.fatcaForm.value.items.length;
      if(len > 0 && this.TaxImage2Id){
        this.fatcaForm.value.items[0].ADDFatcaDetailsId = this.TaxImage2Id;
      }

      if(len === 2 && this.TaxImage3Id){
        this.fatcaForm.value.items[1].ADDFatcaDetailsId = this.TaxImage3Id;
      }
      if(len){
          for(let i = 0; i < len; i++){
              let  p ={
                  "AddressType": "",
                  "TIDocument": 0,
                  "TIN": this.fatcaForm.value.items[i].ADDTIN,
                  "TaxCountry": this.fatcaForm.value.items[i].ADDCTR,
                  "IndianTaxer": false,
                  "FatcaDetailsId": this.fatcaForm.value.items[i].ADDFatcaDetailsId,
                  "Title": this.title,
                  "FirstName": "",
                  "MiddleName":"",
                  "LastName":this.name,
                  "ClientName":"",
                  "FatherOrSpouse":"F",
                  "FatherOrSpouseName":this.relationName,
                  "Occupation":this.Occupation,
                  "AnnualIncome":this.AnnualIncome,
                  "TradingExperience":this.tradingExp,
                  "TinCountry": this.fatcaForm.value.items[i].ADDTID,
                  "DocName": this.fatcaForm.value.items[i].ADDADDRESS
              }
              params["Fatca"].push(p)
          }}
      }
  

  let url = "DIY/DIYUpdateFATCA";
  let checksum = this.erefNo;
  this.loader.start();
  this._http.httpPost(url, params, checksum).subscribe({
      next: (data:any)=>{
          this.loader.stop();
          let val=this.http.decryptUsingAES256(data.OutPut)
          if(val && val.IsSuccess){
            // this.toastr.success(val.Success);
            //  this.nominee.stageValidate();
            //  setTimeout(() => {
            //   if(this.nomineeStatus){
                this.router.navigate(['/bank']);
            //    }
            //  }, 200);
            //  setTimeout(() => {
            //   let nomineeStage = sessionStorage.getItem("nomineeStage");
            //  if(nomineeStage && nomineeStage === "true"){
            //   this.router.navigate(['/bank']);
            //  }
            //  else{
            //   return;
            //  }
            //  }, 500);
            
          }else{
              this.errorComp.ModalShow(val.Error);
              // this.toastr.error(val.Error)
          }
      },
      error: error=>{
          this.loader.stop();
          if(!window.navigator.onLine){
              this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
              // this.toastr.error("It appears that your internet connectivity is slow or please try again.");
          }else{
            this.errorComp.ModalShow(error.error.Message)
            // this.toastr.error(error.error.Message);
          }
      }
  });
    }

    stageValidate(){
      // if(sessionStorage.getItem("nomineeStage") && sessionStorage.getItem("nomineeStage") === "true"){
      //   this.nomineeStatus = true;
      // }
      // if(!this.nomineeStatus){
        this.nominee.stageValidate();
      // }
      setTimeout(() => {
        if(this.nomineeStatus){
          this.nextStage();
        }
      }, 500);
      
    }
    validateAlphanumeric(control: any) {
      const value = control.value;
      const containsLetter = /[a-zA-Z]/.test(value);
      const containsDigit = /\d/.test(value);
      if (!containsLetter || !containsDigit) {
        return { noNumbers: true };
      }
      return null;
    }

    alphaNumeric(event: any) {
      const inputText = event.target.value;
      const sanitizedText = inputText.replace(/[^a-zA-Z0-9.,]/g, ''); 

      if (inputText !== sanitizedText) {
        event.target.value = sanitizedText;
      }
    }
    filter(items: any[], query: string): any[] {
    const lowerCaseQuery = query.toLowerCase();
    return items.filter(item =>
      item.TeleCode.toLowerCase().startsWith(lowerCaseQuery) ||
      item.Name.toLowerCase().startsWith(lowerCaseQuery)
    );
  }
    

    backStage(){
        this.router.navigate(['/visa'], { replaceUrl: true });
    }

    checkCode() {
    let c = '';
    if (this.countryCode && this.countryCode.TeleCode) {
      c = this.countryCode.TeleCode;
    } else {
      c = this.countryCode;
    }
  
    let code = this.countryLists.filter((e: any) => {
      return e.TeleCode === c;
    });
    if (!code || code.length === 0) {
      this.countryCodeError = true;
    } else {
      this.countryCodeError = false;
    }
  }

  telcode(event: any){
    if(event.length > 3){
      event = event.substring(0, event.length-1);
    }
    this.countryCode = event;
  }
  restrictEnter(args: any) {
    if (args.key === "Enter" && args.keyCode == 13)
      args.preventDefault();
  }
      selectCodeEvent(event:any){}
      spaceValidation(event:any){}
      emailOnly(event:any){
        const pattern = /^[-a-zA-Z0-9._@]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove non-email characters from the input value
        event.target.value = inputText.replace(new RegExp(`[^-a-zA-Z0-9._@]+`, 'g'), '');
      }
    }
      mobileEdit(){
        if (!this.disableMobileEdit) {
        this.disableMobileEdit = true;
        this.oldMobile = this.nriMobile;
        this.oldCountrycode = this.countryCode;
        this.countryCode = "";
        this.disableCountrycode = false;
        this.nriMobile = '';
        this.mobValidatebtn = true;
        this.mobCancel = true;
        this.stageValidated = true;
        const mobElement = document.getElementById('mobiles');
        if (mobElement) {
          mobElement.removeAttribute('disabled');
        }
        const id = document.getElementById("mobiles");
        if(id && id.classList.contains('has-value')){
          id.classList.remove('has-value')
        }
      }
      }

      emailEdit(){
        if (!this.disableEmailEdit) {
            this.disableEmailEdit = true;
            this.oldNriEmail = this.nriEmail;
            this.nriEmail = '';
            this.emailValidatebtn = true;
            this.emailCancel = true;
            this.stageValidated = true;
            const emailElement = document.getElementById('email');
            if (emailElement) {
              emailElement.removeAttribute('disabled');
            }
            const id = document.getElementById("email");
            if(id && id.classList.contains('has-value')){
              id.classList.remove('has-value')
            }
          }
      }

      validateMobileNumber() {
        const mobileNumber = this.nriMobile;
      
      
        const repeatedDigitRegex = /(.)\1{4,}/;
        if (repeatedDigitRegex.test(mobileNumber)) {
          this.errorComp.ModalShow("Please enter a valid mobile number");
          // this.toastr.error("Please Enter Valid Mobile Number");
          return false;
        }
      
        return true; 
      }
      validateEmail() {
        const email = this.nriEmail;
        const emailRegex = /^[^@]+@[^@]+\.[^@]+$/;
    
        if (!emailRegex.test(email)) {
            this.errorComp.ModalShow("Please enter a valid email address");
            // this.toastr.error("Please Enter Valid Email Address");
            return false;
        }
    
        return true;
    }
    

      genOTP1(){
        const isValid = this.validateMobileNumber();
        if(!isValid){
          return;
        }
        if(this.nriMobile == ""){
          this.errorComp.ModalShow("Please enter the Mobile Number");
          // this.toastr.error("Please enter the Mobile Number");
          return;
        }
        if(this.countryCode == ""){
          this.errorComp.ModalShow("Please enter the country code");
          // this.toastr.error("Please enter the country code");
          return;
        }
        if(this.nriMobile && this.nriMobile.length < 7){
          this.errorComp.ModalShow("Please enter a valid mobile number")
          // this.toastr.error("Please Provide Valid Mobile Number");
          return;
        }
        const mobElement = document.getElementById('mobiles');
          if (mobElement) {
            mobElement.setAttribute('disabled', 'true');
          }
        this.disableCountrycode = true;
        this.mobCancel = false;
        this.updateMobile();
      }

      updateMobile(){
        const checkSum = this.nriEmail+this.erefNo;
        let ccode = '';
          if(this.countryCode.TeleCode){
            ccode =  this.countryCode.TeleCode;
          }else{
            ccode = this.countryCode;
          }
        const params = {
          "Mobile": this.nriMobile,
          "Email": this.nriEmail,
          "IsMobile":true,
          "ReferenceNumber": this.erefNo,
          "Validate":checkSum,
          "CountryCode": ccode
        }
        this.loader.start();
    
        const path = 'DIY/UpdateEmailMobile';
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
          let mobileVal = this.http.decryptUsingAES256(data.OutPut)
          if(mobileVal.IsSuccess){
            this.loader.stop();
            // this.toastr.success(mobileVal.Success);
            this.mobValidatebtn = false;
            this.disableMobileEdit = false;
            this.stageValidated = false;
            this.disableCountrycode = true;
          }
          else{
            this.loader.stop();
            this.errorComp.ModalShow(mobileVal.Error || "Error Uploading new Data")
            // this.toastr.error(mobileVal.Error || "Error Uploading new Data")
            this.mobValidatebtn = true;
            this.cancelmobotp()
          }
          }
        })
      }

      cancelmobotp(){
        this.disableMobileEdit = false;
        this.nriMobile = this.oldMobile;
        this.countryCode = this.oldCountrycode;
        this.mobValidatebtn = false;
        this.mobCancel = false;
        this.otptriggermob = false;
        this.stageValidated = false;
        this.disableCountrycode = true;
        const mobElement = document.getElementById('mobiles');
        if (mobElement) {
          mobElement.setAttribute('disabled', 'true');
        }
      }

      genOTP(){
        const isValid = this.validateEmail();
        if(!isValid){
          return;
        }
        if(this.nriEmail == ""){
          this.errorComp.ModalShow("Please enter the Email address")
          // this.toastr.error("Please enter the Email address");
          return;
        }
        else{
          const emailElement = document.getElementById('email');
          if (emailElement) {
            emailElement.setAttribute('disabled', 'true');
          }
        this.emailCancel = false;
        this.emailOTP = "";
          let error = 0;
          this.rmfullemail = this.rmEmail + this.rmDomain;
          if(error === 0){
            let checkSum = '';
            if(this.rmAssist){
              checkSum = this.nriEmail + this.rmfullemail;
            }else{
              checkSum = this.nriEmail + this.nriEmail;
            }
           
            const params = {
              "CustomerEmail": this.nriEmail,
              "IsRMJourney": false,
              "RMEmail": "",
              "Email": this.nriEmail,
              "Mobile": this.nriMobile,
              "Update":true,
              "IsEmail":true,
              "IsMobile":false,
            }
            this.loader.start();
            this.reSendOTP = false;
            const path = 'DIY/EmailOtp';
            this._http.httpPost(path, params, checkSum).subscribe({
              next: (data:any)=>{
                let emailValue = this.http.decryptUsingAES256(data.OutPut)
                this.loader.stop();
                if(emailValue && emailValue.IsSuccess){
                  // this.toastr.success("OTP Sent Successfully");
                  this.otptriggerEmail = true;
                  this.emailValidatebtn = false;
                 }else{
                  if(emailValue && emailValue.Error){
                    this.otptriggerEmail = false;
                    this.emailValidatebtn = true;
                    this.errorComp.ModalShow(emailValue.Error);
                    // this.toastr.error(emailValue.Error);
                    this.emailCancel = true;
                    const emailElement = document.getElementById('email');
                      if (emailElement) {
                        emailElement.removeAttribute('disabled');
                      }
                  }else{
                    // this.toastr.error("Please try again later.");
                    this.errorComp.ModalShow("Please try again later.");
                  }
                }
              }, error: e =>{
                this.loader.stop();
    
                const panDetails = e.error.ModelState;
                for (const key in panDetails) {
                  if (panDetails.hasOwnProperty(key)) {
                    const errorMessages = panDetails[key];
                    if (Array.isArray(errorMessages) && errorMessages.length > 0) {
                      this.errorComp.ModalShow(errorMessages[0]);
                      // this.toastr.error(errorMessages[0]);
                      this.emailCancel = true;
                      const emailElement = document.getElementById('email');
                      if (emailElement) {
                        emailElement.removeAttribute('disabled');
                      }
                      return;
                    }
                  }
                }
              }
            }
      )}
      }}
      reSendOTPStatus(event: any){
        this.reSendOTP = event;
      }

      cancelotp(){
        this.disableEmailEdit = false;
        this.nriEmail = this.oldNriEmail;
        this.emailValidatebtn = false;
        this.emailCancel = false;
        this.otptriggerEmail = false;
        this.stageValidated = false;
        const emailElement = document.getElementById('email');
        if (emailElement) {
          emailElement.setAttribute('disabled', 'true');
        }
      }

      numericOnly(event: any) {
        const pattern = /^[0-9\b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          event.target.value = inputText.replace(new RegExp(`[^0-9]+`, 'g'), '');
        }
      }

      togglePasswordVisibility() {
        this.showOTP = !this.showOTP;
        const otpInput = document.getElementById('emotp') as HTMLInputElement;
        otpInput.type = this.showOTP ? 'text' : 'password';
      }

      validateOTP(){
        console.log('emailOTP:', this.emailOTP);
        if(this.emailOTP == ""){
          this.errorComp.ModalShow("Please enter the OTP");
          // this.toastr.error("Please enter the OTP");
          return;
        }
        this.stageValidated = false;
        let checkSum = '';
        if(this.rmAssist){
          checkSum = this.rmfullemail + this.emailOTP;
        }else{
          checkSum = this.nriEmail + this.emailOTP;
        }
        const params = {
          "Email": this.nriEmail,
          "OTP": this.emailOTP,
        }
        this.loader.start();
        const path = 'DIY/ValidateOTP';
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
            this.loader.stop();
            let validateValue = this.http.decryptUsingAES256(data.OutPut)
            if(validateValue.IsSuccess){
              // this.toastr.success("OTP Validated Successfully");
              this.updateEmailMobile();
              this.otptriggerEmail = false;
            }else{
              this.errorComp.ModalShow(validateValue.Error);
              // this.toastr.error(validateValue.Error);
              this.otpError = true;
            }
          }, error: _error =>{
            this.loader.stop();
            this.otpError = true;
            this.errorComp.ModalShow(_error.error.Message);
            // this.toastr.error(_error.error.Message)
      
          }
        });
      
      }

      updateEmailMobile(){
        const checkSum = this.nriEmail+this.erefNo;
        const params = {
          "Mobile": this.nriMobile,
          "Email": this.nriEmail,
          "IsEmail":true,
          "ReferenceNumber": this.erefNo,
          "Validate":checkSum,
        }
    
        const path = 'DIY/UpdateEmailMobile';
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
          let updateEmailMobValue = this.http.decryptUsingAES256(data.OutPut)
            this.loader.stop();
          if(updateEmailMobValue.IsSuccess){
            // this.toastr.success(updateEmailMobValue.Success);
            this.disableEmailEdit = false;
          }
          else{
            this.errorComp.ModalShow("Error Uploading new Data");
            // this.toastr.error("Error Uploading new Data")
          }
          }
        })
      }
}